import EducatorVerification from './educator-verification';

export default EducatorVerification;
